/**
 * Studio Bonaiuti — mark identitario CORPORATE (3 pallini in linea).
 * Rappresenta il brand aziendale, resta invariato in tutti i moduli.
 * Colori ufficiali dal Brand Book Gruppo Impresa Suite v1.0:
 *  - Rosso   #E04B4B (Pantone 186 C)
 *  - Grigio  #A7A9AC (Pantone Cool Gray 7 C)
 *  - Oro     #F2C24B (Pantone 1235 C)
 */
export function BrandMark({ size = 40, className = "" }) {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      viewBox="0 0 64 64"
      width={size}
      height={size}
      className={className}
      role="img"
      aria-label="Studio Bonaiuti"
    >
      <circle cx="12" cy="32" r="9" fill="#E04B4B" />
      <circle cx="32" cy="32" r="9" fill="#A7A9AC" />
      <circle cx="52" cy="32" r="9" fill="#F2C24B" />
    </svg>
  );
}
